import { useLocation } from 'react-router'
import { useMemo } from 'react'
import { NavLink } from '@/generated'
import * as util from '@/util'

export function useNavLink({ appId, pageId, projectId, setParams, toggleParams }: NavLink): {
  pathname: string
  search: string
  active: boolean
  childActive: boolean
} {
  const { pathname, search } = useLocation()

  return useMemo(() => {
    return util.buildNavLink({
      currentPathname: pathname,
      currentSearch: search,
      link: { appId, pageId, projectId, setParams, toggleParams },
    })
  }, [pathname, search, appId, pageId, projectId, setParams, toggleParams])
}
